/**
 * Modelo de cliente enterprise CPaaS.
 *
 * - `code`: identificador interno usado como componente del nombre del fichero de salida
 *   (e.g. "CDR_MACC_Residencial_2025-01.xlsx")
 * - `label`: texto legible para mostrar en dropdowns
 * - `wholesaleCustomerId`: ID que reconoce la API de Document Store de Telekom CPaaS
 *   (parámetro `wholesaleCustomerIds` en GET /v2/files).
 *
 * Cuando esté disponible el endpoint del API que devuelve la lista de clientes,
 * el único cambio necesario es en CpaasClientsService.getClients(): sustituir
 * `return of(CPAAS_CLIENTS)` por la llamada HTTP correspondiente.
 */
export interface CpaasClient {
  /** Código interno; se usa como parte del nombre del fichero XLSX de salida */
  code: string;
  /** Nombre legible para dropdowns */
  label: string;
  /** ID del cliente en la API de Document Store (wholesaleCustomerId) — PLACEHOLDER */
  wholesaleCustomerId: string;
}

export const CPAAS_CLIENTS: CpaasClient[] = [
  {
    code: 'MACC_Residencial',
    label: 'MACC Residencial',
    wholesaleCustomerId: '745d6bc5-649e-4814-b0e0-7400fec5d3a3',
  },
  {
    code: 'MACC_Residencial_Test',
    label: 'MACC Residencial Test',
    wholesaleCustomerId: 'fdfd97e9-aa31-4787-ab1e-b85b57a56be6',
  },
  {
    code: 'MACC_Residencial_Test2',
    label: 'MACC Residencial Test 2',
    wholesaleCustomerId: 'f2377fbe-99bc-465a-899a-ecd3c0c8213b',
  },
];